import ModuleBasketButton from './ModuleBasketButton.vue';

export default ModuleBasketButton;



// WEBPACK FOOTER //
// ./src/components/parts/modules/card/components/modulebasketbutton/index.ts